/** @format */
import React from 'react';
import PropTypes from 'prop-types';

const MRRIcon = ({ 
  className = "h-7 w-7", 
  trend = "positive", // "positive", "negative", "neutral"
  amount = null,
  showPinkAccent = false 
}) => {
  return (
    <div className="relative">
      <svg 
        className={className} 
        viewBox="0 0 32 32" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Monthly recurring revenue icon"
      >
        {/* Credit card base - represents subscription billing */}
        <rect 
          x="4" 
          y="10" 
          width="24" 
          height="14" 
          rx="2" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          fill="none"
        />
        
        {/* Card magnetic stripe */}
        <rect 
          x="4" 
          y="13" 
          width="24" 
          height="2.5" 
          fill="currentColor" 
          opacity="0.6"
        />
        
        {/* Dollar symbol on card */}
        <g transform="translate(16, 19)">
          {/* Dollar sign vertical lines */}
          <path
            d="M0 -2v1M0 2v1"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
          />
          
          {/* Dollar S shape - simplified */}
          <path
            d="M-2 -1c0-1 1-1.5 2-1.5s2 0.5 2 1.5c0 0.7-0.5 1-1.2 1.2L2 1c0 1-1 1.5-2 1.5s-2-0.5-2-1.5"
            stroke="currentColor"
            strokeWidth="1"
            fill="none"
            strokeLinecap="round"
          />
        </g>
        
        {/* Recurring cycle arrows around the card - bigger and more prominent */}
        <g opacity="0.9">
          {/* Top arrow - cash flowing in */}
          <path
            d="M10 6 A10 6 0 0 1 22 6"
            stroke="rgb(204, 29, 185)"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
          />
          <path
            d="M19 4.5 L22 6 L19 7.5"
            stroke="rgb(204, 29, 185)"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          
          {/* Bottom arrow - recurring cycle */}
          <path
            d="M22 28 A10 6 0 0 1 10 28"
            stroke="rgb(204, 29, 185)"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
          />
          <path
            d="M13 29.5 L10 28 L13 26.5"
            stroke="rgb(204, 29, 185)"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        
        {/* Monthly indicator - small "M" for monthly */}
        <text 
          x="26" 
          y="12" 
          textAnchor="middle" 
          fontSize="4" 
          fontFamily="monospace" 
          fill="currentColor"
          fontWeight="600"
          opacity="0.7"
        >
          M
        </text>
      </svg>
    </div>
  );
};

MRRIcon.propTypes = {
  className: PropTypes.string,
  trend: PropTypes.oneOf(['positive', 'negative', 'neutral']),
  amount: PropTypes.number,
  showPinkAccent: PropTypes.bool,
};

export default MRRIcon;